var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternNine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 436,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F87C56",
    d: "M47 277.436H29V0h18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M444.999 344.825H217.823v73.288c0 .075-.03.147-.083.201a.287.287 0 01-.201.083H103.492V436h114.047a17.96 17.96 0 0012.667-5.245c3.36-3.353 5.25-7.9 5.256-12.642v-55.685h209.537v-17.603zM96.065 369.233h72.228a17.654 17.654 0 0112.448 5.154 17.583 17.583 0 015.164 12.422v24.403H53.748l-.194-107.634h-7.096v107.634H0v-17.603h28.82V285.975H71.16l.194 107.634h96.911v-6.773H78.594l-1.042-108.329H28.82v-17.603h66.204l1.042 108.329zm348.934-31.327H121.131l-.119 6.898h89.728v66.444h-17.639v-48.841h-90.032l.722-42.104h341.208v17.603z",
    fill: "#F87C56"
  })));
}
export default SvgIconPatternNine;